import React from 'react';
import cn from 'classnames';
import * as styles from './BurgerBtn.module.scss';

export default function BurgerBtn({ active = false, onClick, theme, fixed = false }) {
  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      onClick();
      e.preventDefault();
    }
  };
  return (
    <div
      className={cn(styles.button, styles[theme], active && styles.active, fixed && styles.fixed)}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label="Open the menu"
      onKeyDown={handleKeyDown}
    >
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
